'use client';

const WHATSAPP_LINK = 'https://wa.me/+8619926823161';

export default function WhatsAppButton() {
  return (
    <>
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
        className="whatsapp-btn"
      >
        {/* Pulse ring */}
        <span className="whatsapp-pulse" />

        {/* WhatsApp SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          width="28"
          height="28"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="24" cy="24" r="24" fill="#25D366" />
          <path
            d="M34.5 13.5A14.85 14.85 0 0 0 24 9C16.27 9 10 15.27 10 23a13.94 13.94 0 0 0 1.87 7L10 38l8.26-1.84A14.94 14.94 0 0 0 24 37.5c7.73 0 14-6.27 14-14.5a14.85 14.85 0 0 0-3.5-9.5z"
            fill="#fff"
          />
          <path
            d="M34.5 13.5A14.85 14.85 0 0 0 24 9C16.27 9 10 15.27 10 23a13.94 13.94 0 0 0 1.87 7L10 38l8.26-1.84A14.94 14.94 0 0 0 24 37.5c7.73 0 14-6.27 14-14.5a14.85 14.85 0 0 0-3.5-9.5z"
            fill="none"
          />
          <path
            d="M20.1 17.5c-.3-.7-.6-.7-.9-.72h-.77a1.48 1.48 0 0 0-1.07.5 4.52 4.52 0 0 0-1.41 3.36c0 1.98 1.44 3.9 1.64 4.17s2.77 4.4 6.83 6c.95.41 1.7.65 2.28.83a5.5 5.5 0 0 0 2.52.16c.77-.12 2.37-.97 2.7-1.9a3.34 3.34 0 0 0 .24-1.9c-.1-.17-.37-.27-.77-.47s-2.37-1.17-2.74-1.3-.63-.2-.9.2-1.03 1.3-1.27 1.57-.47.3-.87.1a10.94 10.94 0 0 1-3.23-2 12.1 12.1 0 0 1-2.24-2.8c-.23-.4 0-.63.18-.83s.4-.47.6-.7a2.72 2.72 0 0 0 .4-.67 .74.74 0 0 0-.03-.7c-.1-.2-.87-2.1-1.2-2.87z"
            fill="#25D366"
          />
        </svg>

        {/* Tooltip label */}
        <span className="whatsapp-label">Chat with us</span>
      </a>

      <style jsx>{`
        .whatsapp-btn {
          position: fixed;
          right: 24px;
          bottom: 96px;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          background: #25D366;
          border-radius: 50%;
          padding: 0;
          box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45), 0 2px 6px rgba(0,0,0,0.18);
          text-decoration: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          overflow: visible;
        }

        .whatsapp-btn:hover {
          transform: translateY(-3px) scale(1.04);
          box-shadow: 0 8px 24px rgba(37, 211, 102, 0.55), 0 4px 10px rgba(0,0,0,0.2);
        }

        .whatsapp-btn:hover .whatsapp-label {
          max-width: 120px;
          opacity: 1;
          margin-right: 8px;
        }

        .whatsapp-label {
          position: absolute;
          right: 64px;
          color: #fff;
          font-size: 13px;
          font-weight: 600;
          white-space: nowrap;
          max-width: 0;
          opacity: 0;
          overflow: hidden;
          background: #25D366;
          padding: 6px 10px;
          border-radius: 20px;
          transition: max-width 0.3s ease, opacity 0.3s ease;
          letter-spacing: 0.01em;
          pointer-events: none;
        }

        .whatsapp-pulse {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 50%;
          background: rgba(37, 211, 102, 0.4);
          animation: whatsapp-pulse 2.2s ease-out infinite;
          pointer-events: none;
        }

        @keyframes whatsapp-pulse {
          0% { transform: scale(1); opacity: 0.7; }
          70% { transform: scale(1.18); opacity: 0; }
          100% { transform: scale(1.18); opacity: 0; }
        }

        @media (min-width: 768px) {
          .whatsapp-btn {
            right: 32px;
            bottom: 104px;
          }
        }
      `}</style>
    </>
  );
}
